// extracted by css-extract-rspack-plugin
export default {"hiringManagerBlock":"hiring-manager-block--_akgK1NXnBsgat4r"};